import React from 'react';
import { Check } from 'lucide-react';

const diferencias = [
  'Integramos nutrición y bienestar desde una mirada innovadora.',
  'Incorporamos el uso responsable de alimentos funcionales y plantas medicinales.',
  'Diseñamos actividades participativas y memorables, no charlas genéricas.',
  'Adaptamos cada programa a la cultura de la empresa.',
  'Medimos resultados para demostrar impacto real.',
];

const Diferencias = () => {
  return (
    <section id="diferencias" className="section bg-white">
      <div className="container max-w-3xl">
        <h2 className="heading-2 mb-10">
          Bienestar que se nota, <em>no que se anuncia</em>
        </h2>
        <div className="space-y-5">
          {diferencias.map((texto) => (
            <div key={texto} className="check-item">
              <span className="check-icon">
                <Check className="w-4 h-4" />
              </span>
              <p className="body-large" style={{ color: 'var(--tinta)' }}>
                {texto}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Diferencias;
